import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import styled from 'styled-components';
import yaml from 'js-yaml';
import { ChoiceTree, useChoiceTree } from './choicecommon_v';
import { MoreInputFields } from './moreinputs'

let enable_submit

function RenderText({condition, setHasValue})
{
    const [value, setValue] = useState('')
    useEffect(() => {
	setHasValue(condition.conditionId, value.length > 0)
    }, [value])
    return (
	<>
	    <div>
		<label class="form-label tertiary-text">{condition.input.label}</label>
		<input type="text"
		       class="form-control tertiary-text"
		       name={condition.conditionId}
		       value={value}
		       onChange={ev => setValue(ev.target.value)}/>
	    </div>
	</>
    )
}
function RenderCondition({condition, setHasValue})
{
    switch(condition.input.type) {
    case 'Text':
	return <RenderText condition={condition} setHasValue={setHasValue}/>
    default:
	console.error('no renderer for type "%O": %O', condition.input.type, condition)
    }
}

function SingleChoiceFieldItems({choices, step})
{
    if ( ! step ) return
    const conditions = ('logic' in step && step.logic && 'onPage' in step.logic && 'onPage' in step.logic ?
			step.logic.onPage : []),
	  [value, setValue] = useState(''),
	  [otherValue, setOtherValue] = useState(''),
	  [hasValue, setHasValue] = useState({}),
	  [moreValidated, setMoreValidated] = useState(!('moreInputs' in step && step.moreInputs && step.moreInputs.length > 0)),
	  hasValueFunc = (condId, hasValue) => {
	      console.log('hasValueFunc: %O, %O', condId, hasValue)
	      setHasValue(prev => ({...prev, [condId]: hasValue}))
	  }
    useEffect(() => {
	if ( value.length == 0 ) {
	    enable_submit(false)
	    return
	}
	if ( step.otherOption === 'addwithinput' && value === step.otherOptionValue && otherValue.length == 0 ) {
	    enable_submit(false)
	    return
	}
	let complete = true
	conditions.forEach(cond => {
	    console.log('check cond: %O', cond)
	    if ( value.trim() != cond.value ) return
	    console.log('check for value: %O in hasValue (%O)', value, hasValue)
	    if ( !(cond.conditionId in hasValue) ) {
		complete = false
		return
	    }
	    if ( ! hasValue[cond.conditionId] ) {
		complete = false
		return
	    }
	})
	console.log('complete = %O, moreValidated = %O', complete, moreValidated)
	enable_submit(complete && moreValidated)
    }, [value, otherValue, hasValue, moreValidated])
    return (
	<>
	    <div style={{display: 'grid',
			 gridTemplateColumns: [...Array(step.numColumns).keys()].map(x => 'auto').join(' ')}}>
		{choices.map((choice, ci) =>
		    <div key={ci} className="form-check">
			<input className="form-check-input"
			       type="radio"
			       value={choice}
			       name={step.dataFields[0].id}
			       id={"id-" + step.dataFields[0].id + "-" + choice}
			       onChange={ev => setValue(ev.target.value)}/>
			<label className="form-check-label tertiary-text"
			       htmlFor={"id-" + step.dataFields[0].id + "-" + choice}>
			    {choice}
			</label>
			{conditions.length > 0 && conditions.map(cond => (
			    cond.value === choice && choice === value && <RenderCondition condition={cond}
											  setHasValue={hasValueFunc}/>
			))}
		    </div>)}
		{'otherOption' in step && step.otherOption !== 'none' && (
		    <>
			<div key={choices.length} className="form-check">
			    <input className="form-check-input"
				   type="radio"
				   value={step.otherOptionValue}
				   name={step.dataFields[0].id}
				   id={"id-" + step.dataFields[0].id + "-" + step.otherOptionValue}
				   onChange={ev => setValue(ev.target.value)}/>
			    <label className="w-100 form-check-label tertiary-text"
				   htmlFor={"id-" + step.dataFields[0].id + "-" + step.otherOptionValue}>
				{step.otherOptionValue}
			    </label>
			</div>
			{value === step.otherOptionValue && step.otherOption === 'addwithinput' && (
			    <div class="mb-2"
				 style={{paddingLeft: '2rem'}}>
				{step.otherInput.numRows === 1 ? (
				    <input type="text"
					   class="form-control"
					   name={step.otherInput.inputId}
					   style={{width: 'auto'}}
					   size={step.otherInput.numCols}
					   placeholder={step.otherInput.label}
					   value={otherValue}
					   onChange={ev => setOtherValue(ev.target.value)}/>
				) : (
				    <textarea class="form-control"
					      rows={step.otherInput.numRows}
					      cols={step.otherInput.numCols}
					      name={step.otherInput.inputId}
					      placeholder={step.otherInput.label}
					      value={otherValue}
					      onChange={ev => setOtherValue(ev.target.value)}
					      style={{width: 'auto'}}/>
				)}
			    </div>
			)}
		    </>
		)}
	    </div>
	    {step && <MoreInputFields step={step} setValidated={setMoreValidated}/>}
	</>
    )
}

function SingleChoiceField({frmid, stepId})
{
    const [step, setStep] = useState(null),
	  [choices, setChoices] = useState(null),
	  [values, setValues, addOrRemoveValue] = useChoiceTree(step ? step.otherOptionValue : null)
    useEffect(() => {
	enable_submit(false)
	if ( frmid && stepId ) {
	    fetch(`/pub/form/${frmid}/${stepId}/`)
		.then(r => r.ok ? r.json() : Promise.reject(r))
		.then(json => {
		    console.log('step = %O', json);
		    setStep(json)
		    setChoices(json.choices)
		})
		.catch(r => {
		    console.error('error in operation: %O, %O', r.status, r.statusText)
		    r.text().then(text => console.error('detail: %O', text))
		})
	}
    }, [frmid, stepId])
    useEffect(() => {
	enable_submit(false)
	if ( values.values.length == 0 ) {
	    enable_submit(false)
	    return
	}
	if ( step.otherOption === 'addwithinput' &&
	     values.values.includes(step.otherOptionValue) &&
	     values.otherValue.length == 0 ) {
	    enable_submit(false)
	    return
	}
	enable_submit(true)
    }, [step, values])
    if ( step ) {
	if ( step.choiceYaml ) {
	    try {
		const tree = yaml.load(step.choiceYaml)
		return <ChoiceTree type="radio"
				   level={1}
				   data={tree}
				   commonProps={step}
				   values={values}
				   setValues={addOrRemoveValue}/>
	    } catch(ex) {
		console.error('unable to parse yaml: %O [ignored]', step.choiceYaml)
	    }
	}
	/* Fallback */
	return <SingleChoiceFieldItems choices={choices} step={step}/>
    } else {
	return (
	    <div class="spinner-border text-primary" role="status">
		<span class="visually-hidden">Loading...</span>
	    </div>
	)
    }
}

(function() {
    const rootId = document.currentScript.getAttribute('data-rootid'),
	  el = document.getElementById(rootId),
	  stepId = el.getAttribute('data-stepid'),
	  frmid = el.getAttribute('data-frmid')
    enable_submit = (enable) => {
	if ( 'enable_submit' in window ) window.enable_submit(stepId, enable)
    }
    createRoot(el).render(<SingleChoiceField frmid={el.getAttribute('data-frmid')}
					     stepId={stepId}/>);
})();
